module.exports = __webpack_public_path__ + "static/illustration-26ab16cdff959c0d280e21e238e8505a.png";